/* Florage Schutzgebiet — Hero-Parallax + Count-up. Failsafe-first. */
(function () {
  'use strict';
  if (window.__flSg) return;
  window.__flSg = true;
  var nf = new Intl.NumberFormat('de-DE');

  var bg = document.querySelector('[data-sg-hero-bg]');
  if (bg && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var tick = function () {
      var off = Math.min(window.scrollY, 700);
      bg.style.transform = 'translateY(' + (off * 0.2) + 'px) scale(1.05)';
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  function run(el) {
    var to = parseInt(el.getAttribute('data-to'), 10) || 0;
    var pre = el.getAttribute('data-prefix') || '';
    var suf = el.getAttribute('data-suffix') || '';
    var dur = 1500, start = null, raf;
    function txt(v) { el.childNodes[0].nodeValue = pre + nf.format(v) + suf; }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      txt(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
    setTimeout(function () { cancelAnimationFrame(raf); txt(to); }, 2600);
  }
  var nums = document.querySelectorAll('[data-countup]');
  if (nums.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.35 });
      Array.prototype.forEach.call(nums, function (n) { io.observe(n); });
    } else {
      Array.prototype.forEach.call(nums, run);
    }
  }
})();
